import { render, staticRenderFns } from "./bf-divider.vue?vue&type=template&id=2d4cd6f7&lang=pug&"
import script from "./bf-divider.vue?vue&type=script&lang=js&"
export * from "./bf-divider.vue?vue&type=script&lang=js&"
import style0 from "./bf-divider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports